import { HttpArcgis } from '../../http';
import { LocalStorage } from '../../localStorage';
import Drop from '../../../assets/Map/drop.svg';
import emptyDrop from '../../../assets/Map/emptyDrop.svg';
import PiezoIcon from  '../../../assets/Map/piezoIcon.svg';
import PiezoIconNegative from  '../../../assets/Map/piezoIconNegative.svg';
import React, { useState } from 'react';
import { fullMapParam } from '../observer';
import { createGlobalStyle } from 'styled-components';
import { app_placeholder } from '../../../env.placeholders';

export const layerIdsByScale = [
  {
    module: 'pr',
    lowScale: [102, 105],
    bigScale: [202, 205],
  },
  {
    module: 'do',
    bigScale: [201, 206],
    lowScale: [101, 106],
  },
  {
    module: 'IndicatorBoonLister',
    bigScale: [212],
    lowScale: [112],
  },
  {
    module: 'IndicatorSejourCana',
    bigScale: [213],
    lowScale: [113],
  },
  {
    module: 'IndicatorSejourPR',
    bigScale: [214],
    lowScale: [114],
  },
  {
    module: 'IndicatorAutocurage',
    bigScale: [215],
    lowScale: [115],
  },
  {
    module: 'IndicatorTerrain',
    bigScale: [216],
    lowScale: [116],
  },
  {
    module: 'ecp',
    bigScale: [207],
    lowScale: [107],
  },
  {
    module: 'indus',
    lowScale: [80],
    bigScale: [80],
  },
  {
    module: 'hydro',
    lowScale: [301, 302, 306],
    bigScale: [301, 302, 306],
  },
  {
    module: 'sensibility',
    bigScale: [208],
    lowScale: [108],
  },
  {
    module: 'dilution',
    bigScale: [209],
    lowScale: [109],
  },
  {
    module: 'pluie',
    bigScale: [211, 210],
    lowScale: [111, 110],
  },
];

export const getModuleType = (pType: string, pPathName: string) => {
  let module: string = pType;
  // specal case for h2s and milieu
  if(pType === 'milieu'){
    module = pPathName.includes('Dilution') === true ? 'dilution' : 'sensibility';
  } else if(pType === 'h2s'){
    const indicatorsList: string[] = [
      'IndicatorBoonLister',
      'IndicatorSejourCana',
      'IndicatorSejourPR',
      'IndicatorAutocurage',
      'IndicatorTerrain',
    ];
    const indicatorIndex: number = indicatorsList.indexOf(window.sessionStorage.getItem('h2s_indicator')!);
    module = indicatorsList[indicatorIndex];
  }
  return module;
};

// define layer id to identify features on click
export const defineLayersAndLayersFilterForIdentify = (
  pViewScale: number,
  pType: string,
  pPathName: string,
) => {

  let layerIds: number[] = [];
  let bigScale: boolean = false;
  const module: string = getModuleType(pType, pPathName);
  // test scale
  if (pViewScale > 24000) {
    bigScale = true;
  }  
  const moduleConfig = layerIdsByScale.find((layer) => layer.module === module);
  if (moduleConfig !== undefined) {
    // exption for hydro popup
    layerIds =
      module === 'hydro' ? [306] : (bigScale === true ? moduleConfig.bigScale : moduleConfig.lowScale);
  }
  return layerIds;
};

// create params for identify request
export const getParamsForIdentify = (pItems: any, pLayerId: any[]) => {
  let getMapServicePlan: any[] = pItems;
  let layers = '';
  let definitionExpression = '{';
  pLayerId.forEach((element) => {
    let getVisibleSublayer: any[] = getMapServicePlan.filter(
      (sublayer: any) => sublayer.id === element,
    );
    getVisibleSublayer.forEach((e) => {
      if (e.definitionExpression) {
        // layers += e.id + ',';
        definitionExpression +=
          '"' + e.id + '" : "' + e.definitionExpression + '",';
      }
      layers += e.id + ',';
    });
  });
  // apply filters of sublayer (visible need to be used)
  definitionExpression = definitionExpression.slice(0, -1);
  definitionExpression += '}';
  layers = layers.slice(0, -1);
  return {
    layers: layers,
    definitionExpression: definitionExpression,
  };
};

//request to get extent of contract selected by user
export const searchContract = async (value, callback, error, contractView) => {
  // force update and override definitionExpression of sublayers by contract code (not sublayers 0,1,11, 7, 17,8,18,9,19 and 10)
  // get sublayers
  const allSublayers: any[] =
    contractView.map.allLayers.items[2].allSublayers.items;
  allSublayers.forEach((sublayer: any) => {
    // apply filter of contract code
    if (sublayer.id === 90) {
      sublayer.definitionExpression = '';
    } else if (
      sublayer.id === 5 ||
      sublayer.id === 3 ||
      sublayer.id === 103 ||
      sublayer.id === 203
    ) {
      sublayer.definitionExpression = "ContractCode in ('" + value + "')";
    }
  });
};

export const getContractExtent = async (pContractId: string) => {
  let res;
  let where = "ContractCode in ('" + pContractId + "')";
  const formBody: string[] = [];
  formBody.push('where=' + where);
  formBody.push('outFields=ContractCode');
  formBody.push('returnExtentOnly=true');
  formBody.push('f=json');
  formBody.push('user=' + LocalStorage.userMail.get());
  const formBodyToSend = formBody.join('&');

  try {
    // launch request
    const responseSections = await HttpArcgis.post(
      app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/5/query',
      JSON.stringify(formBodyToSend),
    );
    res = responseSections.data;
  } catch (error) {
    console.log('Failed to get extent for zooming !', error);
    res = null;
  }
  return res;
};

// create form for identify request
export const createFormIdentify = (
  pMapPoint: any,
  pLayersId: string,
  pDefExp: string,
  pView: any,
) => {
  const formBody: string[] = [];
  formBody.push('geometry=' + pMapPoint.x + ',' + pMapPoint.y);
  formBody.push('geometryType=esriGeometryPoint');
  formBody.push('sr=102100');
  formBody.push('layers=' + pLayersId);
  formBody.push('layerDefs=' + pDefExp);
  formBody.push('tolerance=10');
  formBody.push(
    'mapExtent=' +
      pView.extent.xmin +
      ',' +
      pView.extent.ymin +
      ',' +
      pView.extent.xmax +
      ',' +
      pView.extent.ymax,
  );
  formBody.push('imageDisplay=' + pView.width + ',' + pView.height + '%2C96');
  formBody.push('returnGeometry=false');
  formBody.push('returnZ=false');
  formBody.push('returnM=false');
  formBody.push('returnUnformattedValues=false');
  formBody.push('returnFieldName=true');
  formBody.push('f=json');
  formBody.push('user=' + LocalStorage.userMail.get());
  return formBody.join('&');
};

// method to hide or show filterform and table when you switch to full or not full size map
export const fullScreen = (pFullMap: boolean) => {
  if (pFullMap === true) {
    return 'none';
  } else {
    return 'block';
  }
};

export const paramsLayer = [
  // pluie (seulement Pluviomètre)
  { type: 'pluie', layers: [110, 210], infoBulle: 'Pluviomètre', icon: { show: Drop, hide: emptyDrop }, index: 0 },
  
  // PR (2 boutons : Piézomètre + Pluviomètre)
  { type: 'pr', layers: [117, 217], infoBulle: 'Piézomètre', icon: { show: PiezoIcon, hide: PiezoIconNegative }, index: 1 },
  { type: 'pr', layers: [110, 210], infoBulle: 'Pluviomètre', icon: { show: Drop, hide: emptyDrop }, index: 2 },

  // DO (seulement Pluviomètre)
  { type: 'do', layers: [110, 210], infoBulle: 'Pluviomètre', icon: { show: Drop, hide: emptyDrop }, index: 3 },

  // H2S (seulement Pluviomètre)
  { type: 'h2s', layers: [110, 210], infoBulle: 'Pluviomètre', icon: { show: Drop, hide: emptyDrop }, index: 4 },

  // ECP (2 boutons : Piézomètre + Pluviomètre)
  { type: 'ecp', layers: [117, 217], infoBulle: 'Piézomètre', icon: { show: PiezoIcon, hide: PiezoIconNegative }, index: 2 },
  { type: 'ecp', layers: [110, 210], infoBulle: 'Pluviomètre', icon: { show: Drop, hide: emptyDrop }, index: 3 },
];
 
export const getParamsForDisplayLayerButton = (pModule: string) => {
  return paramsLayer.filter((layer) => layer.type === pModule);
};

/**
 * function to add loader on map
 */
export const addWidget = (pView: any, pWidgetName: string, pPosition: string, pIndex: number) => {
  const widgetDom: HTMLElement | null = document.getElementById(pWidgetName);
  if (widgetDom) {
    pView.ui.add(widgetDom, {
      position: pPosition,
      index: pIndex,
    });
  }
};

/**
 * render of loading
 */
export const loadingDom = (pState: any) => {
  // loading générée à partir de l'url suivante : http://ajaxloadingimages.net/
  const Styles = createGlobalStyle`
    .loaderMap {
      width: 28px;
      height: 28px;
      border: 5px solid white;
      border-top: 5px solid #243977;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
      background-color: transparent;
    }

    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `;
  return (
    <div id='loaderDiv' style={{ display: pState === true ? 'flex' : 'none', border: '0px solid red' }}>
      <Styles />
      <div className='loaderMap'></div>
    </div>
  );
};

export const ZoomButtonDom = (pExtendIcon: any) => {
  // loading générée à partir de l'url suivante : http://ajaxloadingimages.net/
  const [fullMap, setFullMap] = useState(false);
  return (
    <div id='zoomButtonDiv'>
      <div style={{ display: 'flex' }}>
        <img
            className='map-intend'
            id='map-intend'
            alt='map-intend'
            src={pExtendIcon}
            style={{
              backgroundColor: '#fff',
              cursor: fullMap === true ? 'zoom-out' : 'zoom-in',
            }}
            title={fullMap === true ? 'Réduire la carte' : 'Agrandir la carte'}
            onClick={() => {
              fullMapParam.fullMapState(!fullMap);
              setFullMap((prev) => !prev);
            }}
            onKeyDown={() => {
              fullMapParam.fullMapState(!fullMap);
              setFullMap((prev) => !prev);
            }}
          ></img>
      </div>
    </div>
  );
};